import { createContext } from "react";

export interface SmsContextProps {
    sendSms(fromLocationId: number, toPhone: string, text: string): Promise<void>
}

export const SmsContext = createContext<SmsContextProps>(null!)